import { render, staticRenderFns } from "./base-tabs.vue?vue&type=template&id=9dfb47d2&scoped=true"
import script from "./base-tabs.vue?vue&type=script&lang=js"
export * from "./base-tabs.vue?vue&type=script&lang=js"
import style0 from "./base-tabs.vue?vue&type=style&index=0&id=9dfb47d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfb47d2",
  null
  
)

export default component.exports